<template>
<div style="width:100%; display:flex; flex-flow: column nowrap">
    <div class="header-main">
        <div class="section-content">
        <div class="row">
            <h1 class="brand" @click.stop="goToURL('https://www.playlister.club')">Playlister.club</h1>
        </div>
        </div>
    </div>
    <div >
      <div class="d-flex flex-grow-1 pulse flex-column position-relative" >
        <div class="scroller">
            <div class="container flex-grow-1 position-relative ">
                <div class="hero position-relative pb-5 pb-lg-2 ">
                    <div v-if="selectedPulse!=null" class="positioning d-flex flex-grow-1 pr-3 flex-wrap">

                        <div class="title col-lg-6 text-left  front pl-0 pb-2">
                            <img src="~@/assets/img/pulselogo_white.svg" alt="Playlist Pulse" class="m-0 pulse-logo">
                            <h2 class="secondary-font text-white m-0 pl-4  " >{{selectedPulse.Name}} <span class="spotify-link" @click.stop="onOpenPulsePlaylist()"><font-awesome-icon :icon="['fab','spotify']"></font-awesome-icon></span></h2>
                            <p class="description text-white pl-4">{{selectedPulse.Description}}</p>
                        </div>


                        <div class=" col-lg-6  meta-data text-white d-flex flex-column pt-lg-4  front">
                            <select class="drop-selector mb-2" v-model="selectedPulse">
                                <option v-for="chart in pulseItems" :value="chart" :key="'pulseChart_' + chart.Id">{{chart.Name}}</option>
                            </select>
                        <!--  <div class="mt-1 h4 text-right"><label class=" secondary-font">Week #:</label><span class="value  secondary-font">{{selectedPulse.Week}}</span></div> -->
                            <div class="mt-1 h4 text-lg-right"><label class=" secondary-font">Top <span class="value  secondary-font">{{selectedPulse.TotalSongs}}</span> Songs this week</label></div>


                        </div>
                        <div class="floating-text pr-4">
                            {{thisYear}} Week # <span>{{selectedPulse.Week}}</span>
                        </div>
                    </div>

                </div>
                <div class="d-flex flex-row flex-grow-1 flex-wrap ml-2 justify-content-sm-center">
                    <div class="col-lg-3 d-flex flex-column pp-magazine-cta position-relative  text-center">
                        <div class="ribbon"><span>Preview</span></div>
                        <img  :src="magazineThumbnail" :alt="'Playlist Pulse Magazine -' + magazineEdition" class="pulse-cover">
                        <button class="btn-download btn-secondary small p-2 rounded-bottom" @click.stop="onDownloadMagazine()"><FontAwesomeIcon :icon="['fas', 'file-pdf']" class="icon mr-1"></FontAwesomeIcon> Download Preview</button>
                        <p class="pt-4">Get an exclusive preview of our new Playlist Pulse Magazine.</p>

                        <small>For more information about the magazine and/or inquiries regarding future editions please contact:<br/>
                            <a href="mailto:editor@playlistpulse.com">editor@playlistpulse.com</a> <br/> or <a href="mailto:sales@playlistpulse.com">sales@playlistpulse.com</a>
                        </small>
                    </div>
                    <div class=" col-lg-9 flex-grow-1 pt-5">
                            <div class="pulse-content" v-if="pulseItems!=null" >
                            <div class="pulse-songs" v-if="selectedPulseSongs !=null">
                                <div v-if="selectedPulseSongs.length ==0">No available songs.</div>
                                <div v-else class="d-flex flex-wrap ">
                                    <pulse-song v-for="(song, index) in selectedPulseSongs" :key="'pulse_' + selectedPulse.Id + '_' + index" :song="song" :ranking="index + 1" class="col-sm-6 col-md-4 col-xl-3"></pulse-song>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
<!--       <div class="header container">
          <div class="row">
              <div class="header-logo-wrapper">
                  <img class="header-logo" src="@/assets/img/pulselogo_white.svg"
                      alt="Playlist Pulse">
              </div>
              <div>
                  <select class="drop-selector" v-model="selectedPulse">
                      <option v-for="chart in pulseItems" :value="chart" :key="'pulseChart_' + chart.Id">{{chart.Name}}</option>
                  </select>
                  <div class="header-info">
                      <div>
                          <div class="header-info-line-1">
                              <span class="header-info_line-1-week">WEEK # {{selectedPulse.Week}}</span>
                              <span class="color-accent">Songs: {{selectedPulse.TotalSongs}}</span>
                          </div>
                          <div class="header-info-line-2">{{selectedPulse.Name}}</div>
                          <button class="button" @click.stop="()=>{openNewWindow('https://open.spotify.com/playlist/' + selectedPulse.SpotifyPlaylistId)}">
                              <font-awesome-icon class="spotify-logo" :icon="['fab', 'spotify']" /> Follow on Spotify
                          </button>
                      </div>
                  </div>
              </div>
          </div>
          <div class="row">
              <h1 class="header-headline">{{selectedPulse.Description}}</h1>
          </div>
      </div>

      <div class="main container">
          <div class="tracks-grid">
              <div class="track-wrapper" v-for="(track, index) in selectedPulseSongs" :key="'pulseSong_' + track.SpotifySongId + '_' + index"  :title="track.SongName + ' - ' + track.SongSpotifyArtistName">
                  <div class="track track-nominated" v-if="track.NominatedBydbId!='0'">
                      <div class="track-inner">
                          <div class="track-background"
                              :style="'background-image:url(' + track.ArtistImage + ');'"></div>
                          <div class="track-image">
                              <img :src="track.SongImage" alt="">
                          </div>
                          <div class="track-artist" @click.stop="()=>{openNewWindow('https://open.spotify.com/artist/' + track.SongSpotifyArtistId)}">{{track.SongSpotifyArtistName}}</div>
                          <div class="track-info">
                              <div class="track-artwork">
                                  <song-preview :track="formatTrack(track)" :view="'pulse'" class="pulse-song-player" :hideInfo="true" :nocontrols="true"></song-preview>
                              </div>
                              <div class="track-details">
                                  <div class="track-title"  @click.stop="()=>{openNewWindow('https://open.spotify.com/track/' + track.SpotifySongId)}">
                                      {{track.SongName}}
                                  </div>
                                  <div class="track-time">
                                      <font-awesome-icon class="spotify-logo" :icon="['fab', 'spotify']" @click.stop="()=>{openNewWindow('https://open.spotify.com/track/' + track.SpotifySongId)}" />
                                      {{formatMSToTime(track.SongDuration)}}
                                  </div>
                              </div>
                          </div>
                          <div class="nomination-label">
                                <img width="16" src="@/assets/img/icon-curators.svg" alt="">
                          </div>
                          <div class="track-metrics">
                              <div class="track-metric nominated-by">
                                  <div class="label">Nominated By</div>
                                  <div class="data">
                                      <div class="nominator-icon" @click.stop="()=>{openNewWindow('https://open.spotify.com/user/' + track.NominatedBySpotifyUserId)}"
                                          :style="'background-image:url(' + track.NominatedByImage + ');'">
                                      </div>
                                      <div class="nominator-name"  @click.stop="()=>{openNewWindow('https://open.spotify.com/user/' + track.NominatedBySpotifyUserId)}">
                                          {{track.NominatedByName}}
                                      </div>
                                  </div>
                              </div>
                              <div class="track-metric followers">
                                  <div class="label">Followers</div>
                                  <div class="data">{{abbreviateNumber(track.NominatedByFollowers)}}</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="track" v-else>
                      <div class="track-inner">
                          <div class="track-background"
                              :style="'background-image:url(' + track.ArtistImage + ');'"></div>
                          <div class="track-time">
                              <font-awesome-icon class="spotify-logo" :icon="['fab', 'spotify']" @click.stop="()=>{openNewWindow('https://open.spotify.com/track/' + track.SpotifySongId)}" />
                              {{formatMSToTime(track.SongDuration)}}
                          </div>
                          <div class="track-number"> {{track.Ranking}} </div>
                          <div class="track-artist" @click.stop="()=>{openNewWindow('https://open.spotify.com/artist/' + track.SongSpotifyArtistId)}">{{track.SongSpotifyArtistName}} </div>
                          <div class="track-info">
                              <div class="track-artwork">
                                  <song-preview :track="formatTrack(track)" :view="'pulse'" class="pulse-song-player" :hideInfo="true" :nocontrols="true"></song-preview>
                              </div>
                              <div class="track-details">
                                  <div class="track-title"  @click.stop="()=>{openNewWindow('https://open.spotify.com/track/' + track.SpotifySongId)}">
                                      {{track.SongName}}
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

          </div>
      </div> -->
      <div class="footer container text-light">
          <img width="27" height="24" src="@/assets/img/icon-curators.svg" alt="">
          <p class="h4"> Chosen by our leading curators! <span>For more info head to <a href="https://www.playlister.club">www.playlister.club</a></span> </p>
      </div>
      <svg width="0" height="230px">
          <defs>
              <clipPath id="hexa-clip">
              <path d="M279.848 -62H130.152C113.606 -62 98.6364 -53.6202 90.7576 -39.9079L15.9091 85.7888C8.0303 99.5011 8.0303 116.261 15.9091 129.211L90.7576 254.908C98.6364 268.62 113.606 277 130.152 277H279.848C296.394 277 311.364 268.62 319.242 254.908L394.091 129.211C401.97 115.499 401.97 98.7393 394.091 85.7888L319.242 -39.9079C311.364 -53.6202 296.394 -62 279.848 -62Z" fill="white"/>
              </clipPath>
          </defs>
      </svg>
    </div>
    <footer>
      <div class="section-content">
        <span class="copyright">&copy; {{thisYear}} Pentatone Inc. </span>
        <!-- <nav class="footer-nav">
          <ul class="nav-items">
            <li class="nav-item"><a href="https://www.playlister.club/faqs.html" target="_blank">FAQs</a></li>
            <li class="nav-item"><a href="https://www.playlister.club/terms-of-service.html" target="_blank">Terms of Use</a></li>
            <li class="nav-item"><a href="https://www.playlister.club/privacy-policy.html" target="_blank">Privacy Policy</a></li>
          </ul>
        </nav> -->
        <nav class="social">
          <ul class="nav-items">
            <li class="nav-item"><a href="https://open.spotify.com/user/fystyaogi6kcu7t8ul3bw36jr"><font-awesome-icon :icon="['fab', 'spotify']" target="_blank" class="icon"></font-awesome-icon></a></li>
            <li class="nav-item"><a href="https://twitter.com/PlaylisterClub"><font-awesome-icon :icon="['fab', 'twitter']" target="_blank" class="icon"></font-awesome-icon></a></li>
            <li class="nav-item"><a href="https://www.instagram.com/playlisterclub/"><font-awesome-icon :icon="['fab', 'instagram']" target="_blank" class="icon"></font-awesome-icon></a></li>
            <li class="nav-item"><a href="https://www.facebook.com/pg/Playlister-Club-421335835328511" target="_blank"><font-awesome-icon :icon="['fab', 'facebook-f']" class="icon"></font-awesome-icon></a></li>
          </ul>
        </nav>
      </div>
    </footer>
</div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'PulseChart',
  components: {
    FontAwesomeIcon,
    PulseSong: () => import('@/components/PulseSong.vue'),

  },
  data() {
    return {
      settings: {
        root: 'https://api.songtools.io',
        js_appkey_header: 'x-app-key',
        js_appkey_value: '7945643DACBA4335B27300796E8C392A',
        js_auth_cookie: 'datafx_token_7945643DACBA4335B27300796E8C392A',
        flaggedUsers: ['listdmusic', 'neomusic', 'anchors30', 'geij5q1sj6hrz690l9n3k7l42', 'leoblack0'],
      },
      loadingData: false,
      pulseItems: [],
      selectedPulse: {
        Archived: '',
        Description: '',
        Id: '',
        Name: '',
        ReleasedOn: '',
        SpotifyPlaylistId: '',
        TotalSongs: '',
        Week: '',
      },
      selectedPulseSongs: null,
      magazineThumbnail: null,
      magazineURL: null,
      magazineEdition: null,

    };
  },
  computed: {
    thisYear() {
      return new Date().getFullYear();
    },
  },
  watch: {
    selectedPulse() {
      this.loadPulseSongs();
    },
  },
  methods: {
    onDownloadMagazine() {
      window.open(this.magazineURL);
    },
    goToURL(url) {
      window.location = url;
    },
    openNewWindow(url) {
      window.open(url);
    },
    formatTrack(track) {
      const thistrack = track;
      thistrack.TrackId = thistrack.Id;
      return thistrack;
    },
    abbreviateNumber(value) {
      let newValue = value;
      if (value >= 1000) {
        const suffixes = ['', 'k', 'm', 'b', 't'];
        const suffixNum = Math.floor((`${value}`).length / 3);
        let shortValue = '';
        for (let precision = 2; precision >= 1; precision--) {
          shortValue = parseFloat((suffixNum != 0 ? (value / Math.pow(1000, suffixNum)) : value).toPrecision(precision));
          const dotLessShortValue = (`${shortValue}`).replace(/[^a-zA-Z 0-9]+/g, '');
          if (dotLessShortValue.length <= 2) { break; }
        }
        if (shortValue % 1 != 0) var shortNum = shortValue.toFixed(1);
        newValue = shortValue + suffixes[suffixNum];
      }
      return newValue;
    },
    formatMSToTime(s) {
      if (s > 0) {
        const ms = s % 1000;
        s = (s - ms) / 1000;
        let secs = s % 60;
        s = (s - secs) / 60;
        let mins = s % 60;
        const hrs = (s - mins) / 60;
        if (mins < 10) mins = `0${mins}`;
        if (secs < 10) secs = `0${secs}`;
        if (hrs != 0) return `${hrs}:${mins}:${secs}`;
        return `${mins}:${secs}`;
      }
      return '00:00';
    },
    async loadPulseItems() {
      const vm = this;

      const pulseItems = await vm.getData(`${vm.settings.root}/data/pc/playlists/getplaylistpulseeditions`);
      // pulseItems[0].Name = "Playlist Pulse 2020 #12";
      // pulseItems[0].Description = 'This week we took a rollercoaster with the markets, the coronavirus made us all stay home, we’re limited to groups of 10 until further notice, and these were the top hits among our quarantined playlisters:';
      vm.pulseItems = pulseItems;
      vm.selectedPulse = pulseItems[0];
    },
    getData(url) {
      this.initAuthentication($.cookie(this.settings.js_auth_cookie));

      const deferred = $.Deferred();
      $.ajax({
        url,
      }).done((data) => {
        deferred.resolve(data);
      }).fail((error) => {
        console.log(error);
        deferred.reject(error);
      });
      return deferred;
    },
    initAuthentication(token) {
      // we configure the headers only one time using ajax setup
      // Create an Initialize .js and include it in every page or call in every page that requires authentication.
      const headers = {};
      headers[this.settings.js_appkey_header] = this.settings.js_appkey_value;
      headers['x-auth-token'] = token;
      // headers["Content-Type"] = "application/json";
      $.ajaxSetup({
        headers,
        xhrFields: {
          withCredentials: true,
        },
      });
    },
    async loadPulseSongs() {
      const vm = this;
      vm.selectedPulseSongs = null;
      if (vm.selectedPulse != null) {
        vm.loadingData = true;

        const pulseSongs = await this.getData(`${this.settings.root}/data/pc/playlists/getplaylistpulseitems?context=${vm.selectedPulse.Id}`);
        let songRanking = 1;
        pulseSongs.forEach((item, index) => {
          if (item.NominatedBydbId == '0') {
            item.Ranking = songRanking;
            songRanking += 1;
          } else {
            item.Ranking = null;
          }
          item.Id = `${item.SpotifySongId}_${index}`;
          item.Image = item.SongImage;
          //   console.log(item);
        });

        //    console.log(pulseSongs);
        vm.selectedPulseWallSongs = [pulseSongs];
        vm.selectedPulseSongs = pulseSongs;
        vm.loadingData = false;
      }
    },

    async loadPlaylistPulseMagazineInfo() {
      try {
        const magParams = {};
        const req = await this.getData(`${this.settings.root}/data/pc/playlists/getplaylistpulsedetails`);
        if (req) {
          req.forEach((item) => {
            magParams[item.Type] = item.Value;
          });

          this.magazineEdition = magParams.Edition;
          this.magazineURL = magParams.MagazineURL;
          this.magazineThumbnail = magParams.PreviewURL;
        }
      } catch (err) {
        console.warn(err);
      }
    },
    onOpenPulsePlaylist() {
      window.open('https://open.spotify.com/playlist/09zhxAZkXk9mINm25eGqjD?si=8QD4k6rCRzuNZp3PjTSmsw');
    },
  },
  mounted() {
    this.loadPlaylistPulseMagazineInfo();
    this.loadPulseItems();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/scss/_sharedvariables.scss';
   $ribbon-color: #ec0a8d;
   .ribbon {
        position: absolute;
        left: 10px;
        top: -3px;
        z-index: 1;
        overflow: hidden;
        width: 75px;
        height: 75px;
        text-align: right;
        span {
            font-size: 0.55rem;
            font-weight: 800;
            color: $color-white;
            text-transform: uppercase;
            text-align: center;
            line-height: 1.2rem;
            transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            width: 100px;
            display: block;
            background: $ribbon-color;
            box-shadow: 0 3px 10px -5px $color-black;
            position: absolute;
            top: 19px;
            left: -21px;
            &::before {
                content: "";
                position: absolute; left: 0px; top: 100%;
                z-index: -1;
                border-left: 3px solid darken($ribbon-color, 20%);
                border-right: 3px solid transparent;
                border-bottom: 3px solid transparent;
                border-top: 3px solid darken($ribbon-color, 20%);
            }
            &::after {
                content: "";
                position: absolute; right: 0px; top: 100%;
                z-index: -1;
                border-left: 3px solid transparent;
                border-right: 3px solid darken($ribbon-color, 20%);
                border-bottom: 3px solid transparent;
                border-top: 3px solid darken($ribbon-color, 20%);
                }
        }
    }
     .pulse{
        background-image: url('~@/assets/img/bg-pulse.png');
        background-repeat: no-repeat;
        background-size:cover;
        color: $color-white;
    }
    .pp-magazine-cta{
      @media screen and (max-width: $breakpoint-medium-max) {
        align-self: center;
        max-width: 500px;

        margin: 0 auto;
        .pulse-cover{
          width: auto;

        }
        font-size: 1.5rem;
      }
        .btn-download{
            border-radius: 0;
            font-weight: 600;
            vertical-align: middle;
            .icon{
                font-size: 1rem;

            }
        }


    }
        .pulse-logo{
            max-width: 480px;
        }
        .drop-selector{
            background-color: rgba($color-black,0.5);
            border:2px solid rgba(lighten($color-gray, 10%), 0.25);
            color: $color-white;
            font-size: 1rem;
            font-weight: 600;
            width: auto;
            display:block;
            align-self: flex-end;
            height: 40px;
            outline-color: $color-primary;
            margin-right: 0 1rem;
        }
 .floating-text{
        @extend .secondary-font;
        font-size: 3rem;
        color: $gray-800;
        position:absolute;
        right: 0;
        z-index: 0;
        bottom: 0;
        margin:0;
        line-height: 100%;
        vertical-align: baseline;
        span{
            font-size: 8rem;
            color: $black;
            text-shadow: 0 0 3px $gray-200;


        }
    }
    .front{
        z-index: 3;
    }
  .secondary-font{
		font-family: 'League Gothic', sans-serif;
	}
.nomination-label{
    position: absolute;
    top: 15px;
    right: 15px;
    z-index:1;
    img{
        width: 20px;
    }
}
.tile-wall-container{
    min-height: 300px;

    margin: 4px;
    padding-bottom: 2rem;
    margin-bottom: -2rem;
    background: $color-primary;
    overflow:hidden;
    position:absolute;
    top:0;
    height: 90vh;
    left:0; right:0;
    display:flex;
    z-index:1;
    .stretch{
        position:absolute;
        top:0; bottom:0;
        right:0; left: 0;
    }
    &:after{
      content: '';
      position:absolute;
      top:0; bottom:0;
      left:0; right:0;
      z-index: 3;
      background-image: linear-gradient(to top rgba(black, 1) 0 rgba(black, 0) 100%);
    }
    &:before{
        content: '';
        position:absolute;
        z-index:2;
        top: 0; bottom:0;
        left: 0; right:0;
        background-image: linear-gradient(to bottom, rgba(#280505, .90), rgba(rgb(26, 0, 2), .9) 70%, rgba(black, 1) 100%);
    }
}

    .spotify-link{
        font-size: 20px;
        cursor:pointer;
        margin-left: 8px;

        vertical-align: text-top;

        &:hover{
           color: #1DB954;
        }
    }
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.track{
    cursor:default;
}
.track-artwork{
    display:flex;
    flex-flow: column nowrap;
}
.button{
    background-color: transparent;
    border: 2px solid $color-white;
    border-radius: 100px;
    padding: 0.5rem 1.25rem;
    color: $color-white;
    margin: 1rem auto;
    display:flex;
    align-items: center;
    margin-left:0;
    font-weight: 600;
    font-size: 0.9rem;
    transition: all ease-in 200ms;
    cursor:pointer;
     &:hover{
        background-color: rgb(28, 215, 96);
        border-color: rgb(28, 215, 96);
    }
}
.spotify-logo{
    margin: 0 0.75rem 0 0;
    font-size: 1.25rem;

}
.track-artist, .track-title, .nominator-name{
    cursor:pointer;
    &:hover{
        text-decoration: underline;
    }
}
.drop-selector{
    background-color: rgba($color-black,0.5);
    border:2px solid lighten($color-black, 10%);
    color: $color-white;
    font-size: 1rem;

    margin: 1rem 0;
    display:block;
    align-self: center;
    height: 40px;
    outline-color: $color-primary;
    width: 100%;
}
.track-title{
    font-size: 16px !important;
    width:95%;
    line-height: 120%;
}
.track-details{
    width: 100%;
}
</style>
<style lang="scss">
.song-cite{
    flex:1;
    overflow:hidden;
}
</style>
